/*
 * @Description:
 * @Author: fiveonelei
 * @Date: 2022-02-09 15:55:29
 * @FilePath: /vise/packages/app-share/src/constants/schema.ts
 */
import { EMaterialCategory } from '@/constants/feed';

export const SCHEMA_MAP = {
  [EMaterialCategory.h5Activity]({ exposure_material_id: exposureMaterialId = '' }, extraParams = '') {
    return `weishi://materialcollec?&material_id=${exposureMaterialId}&cate_id=h5_activity&ios_min_version=6.6.5&android_min_version=6.6.5${
      extraParams ? `&${extraParams}` : ''
    }`;
  },
  [EMaterialCategory.camera](
    {
      exposure_material_id: exposureMaterialId = '',
      ios_min_version_str: iosMinVersion = '',
      android_min_version_str: androidMinVersion = '',
    },
    extraParams = '',
    useCamera: boolean,
  ) {
    if (useCamera) {
      return `weishi://camera?effect_id=${exposureMaterialId}&material_id=${exposureMaterialId}&cate_id=camera&ios_min_version=${iosMinVersion}&android_min_version=${androidMinVersion}${
        extraParams ? `&${extraParams}` : ''
      }`;
    }
    return `weishi://materialcollec?&material_id=${exposureMaterialId}&cate_id=camera&ios_min_version=${iosMinVersion}&android_min_version=${androidMinVersion}${
      extraParams ? `&${extraParams}` : ''
    }`;
  },
  [EMaterialCategory.wsInteractTemplate](
    {
      exposure_material_id: exposureMaterialId = '',
      ios_min_version_str: iosMinVersion = '',
      android_min_version_str: androidMinVersion = '',
    },
    extraParams = '',
  ) {
    return `weishi://camera?interact_id=${exposureMaterialId}&material_id=${exposureMaterialId}&cate_id=ws_interact_template&ios_min_version=${iosMinVersion}&android_min_version=${androidMinVersion}${
      extraParams ? `&${extraParams}` : ''
    }`;
  },
  [EMaterialCategory.videofunny](
    {
      exposure_material_id: exposureMaterialId = '',
      ios_min_version_str: iosMinVersion = '',
      android_min_version_str: androidMinVersion = '',
    },
    extraParams = '',
  ) {
    return `weishi://picker?material_id=${exposureMaterialId}&cate_id=videofunny&ios_min_version=${iosMinVersion}&android_min_version=${androidMinVersion}${
      extraParams ? `&${extraParams}` : ''
    }`;
  },
  [EMaterialCategory.recommendTemplate](
    {
      exposure_material_id: exposureMaterialId = '',
      ios_min_version_str: iosMinVersion = '',
      android_min_version_str: androidMinVersion = '',
    },
    extraParams = '',
  ) {
    return `weishi://picker?material_id=${exposureMaterialId}&cate_id=autoTemplate&ios_min_version=${iosMinVersion}&android_min_version=${androidMinVersion}${
      extraParams ? `&${extraParams}` : ''
    }`;
  },
  [EMaterialCategory.unknown](
    { ios_min_version_str: iosMinVersion = '', android_min_version_str: androidMinVersion = '' },
    extraParams = '',
  ) {
    return `weishi://camera?ios_min_version=${iosMinVersion}&android_min_version=${androidMinVersion}${
      extraParams ? `&${extraParams}` : ''
    }`;
  },
};
